var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 17.0625H2.25C1.9425 17.0625 1.6875 16.8075 1.6875 16.5C1.6875 16.1925 1.9425 15.9375 2.25 15.9375H15.75C16.0575 15.9375 16.3125 16.1925 16.3125 16.5C16.3125 16.8075 16.0575 17.0625 15.75 17.0625Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 6.28497H3C2.5875 6.28497 2.25 6.62247 2.25 7.03497V13.5C2.25 13.9125 2.5875 14.25 3 14.25H4.2C4.6125 14.25 4.95 13.9125 4.95 13.5V7.03497C4.95 6.61497 4.6125 6.28497 4.2 6.28497Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5999 3.89252H8.3999C7.9874 3.89252 7.6499 4.23002 7.6499 4.64252V13.5C7.6499 13.9125 7.9874 14.25 8.3999 14.25H9.5999C10.0124 14.25 10.3499 13.9125 10.3499 13.5V4.64252C10.3499 4.23002 10.0124 3.89252 9.5999 3.89252Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.5H13.8C13.3875 1.5 13.05 1.8375 13.05 2.25V13.5C13.05 13.9125 13.3875 14.25 13.8 14.25H15C15.4125 14.25 15.75 13.9125 15.75 13.5V2.25C15.75 1.8375 15.4125 1.5 15 1.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "97120/static/media/Chart.d9f1fe603820576196c8da2a41677f07.svg";
export { ForwardRef as ReactComponent };